module.exports = __webpack_public_path__ + "static/media/coffeebar_thumb_even.d2ffd19b.webp";